var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmoInstagramIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: url(#radial-gradient);\n      }\n\n      .st2 {\n        fill: url(#radial-gradient1);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 217.6,
    cy: -344.2,
    fx: 217.6,
    fy: -344.2,
    r: 21.9,
    gradientTransform: "translate(-2556.2 1963.6) rotate(-90) scale(8.1 -7.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff543e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c837ab"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: 99.9,
    cy: -308.5,
    fx: 99.9,
    fy: -308.5,
    r: 21.9,
    gradientTransform: "translate(4431.6 -1250.7) rotate(78.7) scale(3.6 -15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3771c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3771c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60f",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90,0C52.5,0,41.5,0,39.3.2c-7.7.6-12.5,1.9-17.7,4.5-4,2-7.2,4.3-10.3,7.6C5.5,18.2,2.1,25.5.8,34.2.2,38.4,0,39.2,0,60.7,0,67.9,0,77.3,0,90,0,127.5,0,138.5.2,140.6c.6,7.5,1.8,12.2,4.3,17.4,4.8,9.9,13.9,17.3,24.6,20.1,3.7,1,7.8,1.5,13.1,1.7,2.2,0,24.9.2,47.7.2s45.5,0,47.6-.1c6.1-.3,9.6-.8,13.5-1.8,10.8-2.8,19.7-10.1,24.6-20.1,2.4-5,3.7-9.9,4.2-17.1.1-1.6.2-26.3.2-51s0-49.4-.2-50.9c-.6-7.2-1.8-12.1-4.3-17.2-2.1-4.2-4.4-7.3-7.7-10.6-6-5.7-13.2-9.1-21.9-10.4-4.2-.6-5-.8-26.6-.8h-29.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90,0C52.5,0,41.5,0,39.3.2c-7.7.6-12.5,1.9-17.7,4.5-4,2-7.2,4.3-10.3,7.6C5.5,18.2,2.1,25.5.8,34.2.2,38.4,0,39.2,0,60.7,0,67.9,0,77.3,0,90,0,127.5,0,138.5.2,140.6c.6,7.5,1.8,12.2,4.3,17.4,4.8,9.9,13.9,17.3,24.6,20.1,3.7,1,7.8,1.5,13.1,1.7,2.2,0,24.9.2,47.7.2s45.5,0,47.6-.1c6.1-.3,9.6-.8,13.5-1.8,10.8-2.8,19.7-10.1,24.6-20.1,2.4-5,3.7-9.9,4.2-17.1.1-1.6.2-26.3.2-51s0-49.4-.2-50.9c-.6-7.2-1.8-12.1-4.3-17.2-2.1-4.2-4.4-7.3-7.7-10.6-6-5.7-13.2-9.1-21.9-10.4-4.2-.6-5-.8-26.6-.8h-29.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90,23.6c-18,0-20.3,0-27.4.4-7.1.3-11.9,1.4-16.1,3.1-4.4,1.7-8.1,4-11.8,7.7-3.7,3.7-6,7.4-7.7,11.8-1.6,4.2-2.8,9.1-3.1,16.1-.3,7.1-.4,9.4-.4,27.4s0,20.3.4,27.4c.3,7.1,1.4,11.9,3.1,16.1,1.7,4.4,4,8.1,7.7,11.8,3.7,3.7,7.4,6,11.8,7.7,4.2,1.6,9.1,2.8,16.1,3.1,7.1.3,9.4.4,27.4.4s20.3,0,27.4-.4c7.1-.3,11.9-1.4,16.1-3.1,4.4-1.7,8.1-4,11.8-7.7,3.7-3.7,6-7.4,7.7-11.8,1.6-4.2,2.8-9.1,3.1-16.1.3-7.1.4-9.3.4-27.4s0-20.3-.4-27.4c-.3-7.1-1.5-11.9-3.1-16.1-1.7-4.4-4-8.1-7.7-11.8-3.7-3.7-7.4-6-11.8-7.7-4.2-1.6-9.1-2.8-16.1-3.1-7.1-.3-9.3-.4-27.4-.4h0ZM84,35.5c1.8,0,3.7,0,6,0,17.7,0,19.8,0,26.9.4,6.5.3,10,1.4,12.3,2.3,3.1,1.2,5.3,2.6,7.6,5,2.3,2.3,3.8,4.5,5,7.6.9,2.3,2,5.9,2.3,12.3.3,7,.4,9.1.4,26.8s0,19.8-.4,26.8c-.3,6.5-1.4,10-2.3,12.3-1.2,3.1-2.6,5.3-5,7.6-2.3,2.3-4.5,3.8-7.6,5-2.3.9-5.9,2-12.3,2.3-7,.3-9.1.4-26.9.4s-19.8,0-26.9-.4c-6.5-.3-10-1.4-12.3-2.3-3.1-1.2-5.3-2.6-7.6-5-2.3-2.3-3.8-4.5-5-7.6-.9-2.3-2-5.9-2.3-12.3-.3-7-.4-9.1-.4-26.9s0-19.8.4-26.8c.3-6.5,1.4-10,2.3-12.3,1.2-3.1,2.6-5.3,5-7.6,2.3-2.3,4.5-3.8,7.6-5,2.3-.9,5.9-2,12.3-2.3,6.1-.3,8.5-.4,20.9-.4h0ZM125.5,46.6c-4.4,0-8,3.6-8,8,0,4.4,3.6,8,8,8s8-3.6,8-8h0c0-4.4-3.6-8-8-8h0ZM90,55.9c-18.8,0-34.1,15.3-34.1,34.1s15.3,34.1,34.1,34.1c18.8,0,34.1-15.3,34.1-34.1s-15.3-34.1-34.1-34.1h0ZM90,67.9c12.2,0,22.1,9.9,22.1,22.1s-9.9,22.1-22.1,22.1-22.1-9.9-22.1-22.1,9.9-22.1,22.1-22.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmoInstagramIcon1);
export default __webpack_public_path__ + "static/media/OMO-Instagram-Icon (1).a190ff0e38527b30b31296236a96e155.svg";
export { ForwardRef as ReactComponent };